import { Copy, Check, Eye } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { Button } from "@/components/ui/button";

interface PreviewLinkBannerProps {
  studioId: string;
  studioHandle?: string | null;
  previewToken?: string | null;
  isLive: boolean;
}

export function PreviewLinkBanner({
  studioId,
  studioHandle,
  previewToken,
  isLive,
}: PreviewLinkBannerProps) {
  const [isCopied, setIsCopied] = useState(false);

  // Don't show banner if studio is live or no preview token
  if (isLive || !previewToken) return null;

  const previewUrl = studioHandle
    ? `${window.location.origin}/${studioHandle}?preview=${previewToken}`
    : `${window.location.origin}/studios/${studioId}?preview=${previewToken}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(previewUrl);
      setIsCopied(true);
      toast.success("Preview link copied to clipboard!");
      setTimeout(() => setIsCopied(false), 2000);
    } catch {
      toast.error("Failed to copy to clipboard");
    }
  };

  return (
    <div className="mx-2 mb-4 p-3 rounded-lg bg-amber-500/10 border border-amber-500/20">
      <div className="flex items-center gap-2 mb-2">
        <Eye className="h-4 w-4 text-amber-500" />
        <span className="text-sm font-medium text-on-dark">Test Link</span>
      </div>
      <p className="text-xs text-on-dark-muted mb-3">
        Share this link to preview your studio before going live.
      </p>
      <Button
        variant="outline"
        size="sm"
        onClick={copyToClipboard}
        className="w-full"
      >
        {isCopied ? (
          <>
            <Check className="h-3 w-3 mr-1 text-green-500" />
            COPIED!
          </>
        ) : (
          <>
            <Copy className="h-3 w-3 mr-1" />
            COPY LINK
          </>
        )}
      </Button>
    </div>
  );
}
